import { createContext } from 'react';
import { authService } from '@/services/AuthService';
import { userService } from '@/services/UserService';
import { analyticsService } from '@/services/AnalyticsService';
import { transactionService } from '@/services/TransactionService';
import { giftcardService } from '@/services/GiftcardService';
import { cryptoService } from '@/services/CryptoService';
import { systemService } from '@/services/SystemService';
import { notificationService } from '@/services/NotificationService';

export interface ApiContextType {
  auth: typeof authService;
  user: typeof userService;
  analytics: typeof analyticsService;
  transaction: typeof transactionService;
  giftcard: typeof giftcardService;
  crypto: typeof cryptoService;
  system: typeof systemService;
  notification: typeof notificationService;
}

export const ApiContext = createContext<ApiContextType | undefined>(undefined);